import './UploadProgressToast.scss';
import React from 'react';
import { Icon } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUploadProgress } from '../../../../hooks/useUploadProgress';

function UploadProgressToast() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    uploading,
    uploadMinimized,
    uploadProgress,
    activeUploadType,
    requestRestore,
    getUploadTypeTitle,
  } = useUploadProgress();

  if (!uploading || !uploadMinimized) {
    return null;
  }

  const title = getUploadTypeTitle(activeUploadType);
  const hint = t('messages.aml.uploadMinimizedHint');

  const handleRestore = () => {
    if (!requestRestore()) {
      return;
    }

    if (!location.pathname.startsWith('/registro')) {
      navigate('/registro');
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleRestore();
    }
  };

  return (
    <button
      type="button"
      className="upload-progress-toast"
      onClick={handleRestore}
      onKeyDown={handleKeyDown}
    >
      <Icon type="loading" className="upload-progress-toast__icon" />
      <span className="upload-progress-toast__text">
        {title}: {uploadProgress || 0}% — {hint}
      </span>
    </button>
  );
}

export default UploadProgressToast;
